import * as L from 'leaflet';
import { environment } from '../../environments/environment';

// Class implementing IRouter interface
/**
 * Custom class implementing L.Routing.IRouter
 * <br>
 * This implementation uses our ORS instance for directions within LRM rather then using LRM's default (OSRM demo server)
 */
export class CustomORSRouter implements L.Routing.IRouter {
  private serviceUrl: string;
  private language: string;

  constructor(language = "fr", serviceUrl: string = environment.ors + '/directions/driving-hgv/geojson') {
    this.language = language;
    this.serviceUrl = serviceUrl;
  }

  /**
   * Implementation of the L.Routing.IRouter's route function. Queries our own ORS instance for directions
   * @param waypoints
   * @param callback
   * @param context
   * @param options
   */
  public route(
    waypoints: L.Routing.Waypoint[],
    callback: (error?: L.Routing.IError | undefined, routes?: L.Routing.IRoute[]) => void,
    context?: any,
    options?: L.Routing.RoutingOptions
  ): this {
    fetch(this.serviceUrl ?? "", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        coordinates: waypoints.map(wp => [wp.latLng.lng, wp.latLng.lat]),
        language: this.language,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(L.bind((data: any) => {
        const routes = this.convertORSResponse(data, waypoints);

        callback.call(context || callback, undefined, routes);
      }))
      .catch((err) => {
        console.error('Error in routing:', err);
        callback(err);
      });
    return this;
  }

  /**
   * Parse ORS response into a LRM-compatible format
   * @param data
   * @param waypoints
   */
  convertORSResponse(data: any, waypoints: L.Routing.Waypoint[]): any[] {
    return data.features.map((feature: any) => ({
      name: 'Custom Route',
      summary: {
        totalDistance: feature.properties.summary.distance,
        totalTime: feature.properties.summary.duration,
      },
      coordinates: L.GeoJSON.coordsToLatLngs(feature.geometry.coordinates/*.map((coords: any[]) => coords.reverse())*/),
      waypoints: feature.properties.way_points,
      inputWaypoints: waypoints,
      instructions: feature.properties.segments[0].steps.map((step: any) => ({
        distance: +step.distance,
        time: +step.duration,
        text: step.instruction,
      })),
    }));
  }
}




